import axios from "axios";
import defaultSetting from "./defaultSetting";

let serviceBaseUrl = "";

process.env.NODE_ENV === "production"
  ? (serviceBaseUrl = `${defaultSetting.tadPath}`)
  : (serviceBaseUrl = "");
const service = axios.create({
  // withCredentials: true, // send cookies when cross-domain requests
  baseURL: serviceBaseUrl, // url = base url + request url
  timeout: 5000, // request timeout
});
export default service;
